import Routers from './Route'
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import QueryProvider  from './multyhealth/Providers/ProviderClient';

const App = () => (
  <div className='App'>
    <CustomizerProvider>                                 
      <AnimationThemeProvider>
        <QueryProvider>
          <Routers />
        </QueryProvider>
      </AnimationThemeProvider>                  
    </CustomizerProvider>
  </div>
);

export default App;
